import BreedingCell from '../components/DataTable/BreedingCell';
import LotCell from '../components/DataTable/LotCell';
import ResponsiveHeader from '../components/DataTable/ResponsiveHeader';

const DATA_TITLE = 'data-title';
const rootData = document.getElementById('root').dataset || {};

const urlPrefix = '/bloodstock/sales/catalogues/';

/**
 * Config for previously sold lots table
 */
export default {
    url: `${urlPrefix}${rootData.venueid}/${rootData.salesdate}/previously-offered-lots/data.json`,
    columns: [
        {
            columnName: 'current_lot_number',
            customHeader: {
                component: ResponsiveHeader,
                options: {
                    displayName: [
                        {
                            className: 'hidden-md-up',
                            displayName: '#'
                        },
                        {
                            className: 'hidden-sm-down',
                            displayName: 'Lot'
                        }
                    ]
                }
            },
            headerDataAttrs: {
                [DATA_TITLE]: 'lotNo'
            },
            customCell: {
                component: LotCell,
                options: {
                    uid: rootData.venueid,
                    date: rootData.salesdate,
                    letter: 'current_lot_letter'
                }
            }
        },
        {
            columnName: 'colour',
            displayName: 'Col',
            headerDataAttrs: {
                [DATA_TITLE]: 'colour'
            }
        },
        {
            columnName: 'sex',
            displayName: 'Sex',
            headerDataAttrs: {
                [DATA_TITLE]: 'sex'
            }
        },
        {
            columnName: 'sire_style_name',
            displayName: 'Breeding',
            headerDataAttrs: {
                [DATA_TITLE]: 'breeding'
            },
            customCell: {
                component: BreedingCell,
                options: {
                    sireUid: 'sire_uid',
                    sireName: 'sire_style_name',
                    damUid: 'dam_uid',
                    damName: 'dam_style_name'
                }
            }
        },
        {
            columnName: 'price',
            displayName: 'Price',
            headerDataAttrs: {
                [DATA_TITLE]: 'price'
            }
        },
        {
            columnName: 'sale_name',
            displayName: 'Sale name',
            headerDataAttrs: {
                [DATA_TITLE]: 'saleName'
            }
        },
        {
            columnName: 'buyer_detail',
            displayName: 'Buyer',
            headerDataAttrs: {
                [DATA_TITLE]: 'buyer'
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./src/js/config/previouslySoldLotsTable.js